/* eslint-disable react/jsx-key */
import clsx from 'clsx';

import styles from '../../styles.module.scss';
import { listMobile as unknownBrowserListMobile } from '../../Unknown/content';
import ImageDesktop1 from '../images/edge-desktop-1.png';
import ImageDesktop2 from '../images/edge-desktop-2.png';

export const listDesktop = [
    <div className={clsx(styles.contentDesktop, styles.center)}>
        Нажмите на&nbsp;значок c&nbsp;замком&nbsp;
        <img src={ImageDesktop1} alt='' />
        &nbsp;в&nbsp;адресной строке
    </div>,
    <div className={clsx(styles.contentDesktop, styles.column)}>
        В&nbsp;появившемся окне разрешите доступ для микрофона/ камеры
        <img className={styles.image} src={ImageDesktop2} alt='' />
    </div>,
];

export const listMobile = unknownBrowserListMobile;
